import { groq } from "next-sanity"

import { AppSettings } from "@/settings"

import { checkPermissions } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"
import { groqQueryOptions } from "../../shared/utils/groqQueryOptions"

export const queryProductCategories = {
  async productCategories(_parent, args, context, _info) {
    let { offset, limit, mainOnly, sort, sortWithinLimits, lang = AppSettings.defaultLocale(), cdn = true } = args

    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.PRODUCTS,
      operation: Operations.READ,
    })

    const config = AppSettings.sanityConfigByLang(lang)
    const client = context.sanityClient
    client.config({ ...config, useCdn: cdn })

    offset = offset ?? 0
    limit = limit ?? -1
    sort = sort ?? ""

    const { pipesAndLimits, draftsFilter } = groqQueryOptions({
      sort,
      offset,
      limit,
      sortWithinLimits,
      includeDrafts: true,
    })

    const excludeMain = mainOnly ? " && parentCategory == null" : ""

    let categories
    categories = await client.fetch(
      groq`{
        "total": count(*[_type=="category"]),
        "items": *[_type=="category"${excludeMain}${draftsFilter}]${pipesAndLimits} {
            ...,
            "revId": _id,
            parentCategory->,
            "subCategories": *[_type=="category" && parentCategory._ref == ^._id]
        }
      }`,
    )

    if (!categories)
      categories = {
        offset,
        limit,
        count: 0,
        total: 0,
        items: [],
      }

    categories = {
      ...categories,
      offset,
      limit,
      count: categories.items.length,
    }

    return categories
  },
}
